var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#FDCF19",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7626 35.0385L19.497 35.0385C18.5283 35.0385 18.1255 36.2781 18.9093 36.8475L32.8773 46.9959C33.2278 47.2506 33.3745 47.7019 33.2406 48.114L27.9053 64.5344C27.6059 65.4558 28.6604 66.2219 29.4441 65.6525L43.4122 55.5041C43.7627 55.2494 44.2373 55.2494 44.5878 55.5041L58.5559 65.6525C59.3396 66.2219 60.3941 65.4558 60.0947 64.5344L54.7594 48.114C54.6255 47.7019 54.7722 47.2506 55.1227 46.9959L69.0907 36.8475C69.8745 36.2781 69.4717 35.0385 68.503 35.0385L51.2374 35.0385C50.8042 35.0385 50.4203 34.7595 50.2864 34.3475L44.9511 17.9271C44.6517 17.0057 43.3483 17.0057 43.0489 17.9271L37.7136 34.3475C37.5797 34.7595 37.1958 35.0385 36.7626 35.0385Z",
    strokeWidth: 4,
    stroke: "#FDCF19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star1.4cf91d27b35553f16fc5e29cc8913033.svg";
export { ForwardRef as ReactComponent };